/**
 * Sprint 81 — Section "Comptable & CFO" dans TenantSettings.
 * Configure les destinataires du cron export mensuel + du recap SEPA + des alertes Bridge.
 */
import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Save } from "lucide-react";
import { toast } from "sonner";

export default function CfoAccountantCard() {
  const [state, setState] = useState({ cfo_email: "", accountant_email: "" });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/tenant/settings")
       .then((r) => {
         const b = r.data.billing || {};
         setState({
           cfo_email: b.cfo_email || "",
           accountant_email: b.accountant_email || "",
         });
       })
       .catch((e) => toast.error(apiError(e)))
       .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/tenant/settings", state);
      toast.success("Destinataires enregistrés");
    } catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  if (loading) return null;
  return (
    <Card data-testid="cfo-accountant-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Mail className="w-4 h-4 text-blue-600" />
          Comptable & CFO
        </CardTitle>
        <p className="text-sm text-slate-500">
          Configurez les destinataires des emails automatiques :
          récap remise SEPA, alerte Bridge, export mensuel du rapprochement.
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <Label>Email CFO (récap SEPA + alertes Bridge)</Label>
          <Input type="email" value={state.cfo_email}
                 onChange={(e) => setState({ ...state, cfo_email: e.target.value })}
                 placeholder="cfo@masociete.com"
                 data-testid="cfo-email-input" />
        </div>
        <div>
          <Label>Email comptable (export Excel mensuel — 1er du mois)</Label>
          <Input type="email" value={state.accountant_email}
                 onChange={(e) => setState({ ...state, accountant_email: e.target.value })}
                 placeholder="cabinet@expert-comptable.fr"
                 data-testid="accountant-email-input" />
        </div>
        <div className="flex justify-end">
          <Button onClick={save} disabled={saving} data-testid="save-cfo-btn">
            <Save className="w-4 h-4 mr-2" />Enregistrer
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
